import { makeStyles } from '@material-ui/core';
import { useMemo } from 'react';

const getVariantDefaultStyles = (theme) => ({
  root: {
    ...theme.typography.button,
    borderRadius: theme.borderRadius.small,
    '& > *:not(:first-child)': {
      marginLeft: 8,
    },
  },

  colorPrimary: {
    color: theme.palette.common.white,
    backgroundColor: theme.colors.brandAction,
    border: `1px solid ${theme.colors.brandAction}`,
    '&:not($disabled):hover': {
      backgroundColor: theme.colors.brandHover,
    },
    '&$disabled': {
      backgroundColor: theme.colors.greyE8,
      color: theme.colors.grey99,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },
  colorSecondary: {
    color: theme.colors.grey66,
    border: `1px solid ${theme.colors.greyCc}`,
    '&:not($disabled):hover': {
      backgroundColor: 'rgba(227, 232, 232, 0.6)',
    },
    '&$disabled': {
      color: theme.colors.greyCc,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },
  colorPure: {
    color: theme.colors.grey66,
    '&$disabled': {
      color: theme.colors.greyCc,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },
  colorDanger: {
    color: theme.palette.common.white,
    backgroundColor: theme.colors.red,
    border: `1px solid ${theme.colors.red}`,
    '&:not($disabled):hover': {
      backgroundColor: theme.colors.redDark,
    },
    '&$disabled': {
      backgroundColor: theme.colors.greyE8,
      color: theme.colors.grey99,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },
  colorGreen: {
    color: theme.palette.common.white,
    backgroundColor: theme.colors.green,
    border: `1px solid ${theme.colors.green}`,
    '&:not($disabled):hover': {
      backgroundColor: theme.colors.greenDark,
    },
    '&$disabled': {
      backgroundColor: theme.colors.greyE8,
      color: theme.colors.grey99,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },

  sizeDefault: {
    padding: '7px 24px',
  },
  sizeSmall: {
    ...theme.typography.h6,
    padding: '7px 16px',
  },
  sizeLarge: {
    padding: '11px 40px',
  },

  disabled: {},
});
const useVariantDefaultStyles = makeStyles(getVariantDefaultStyles);

const getVariantTextStyles = (theme) => ({
  root: {
    ...theme.typography.button,
    color: theme.colors.grey66,
    '& > *:not(:first-child)': {
      marginLeft: 8,
    },
  },

  colorPrimary: {
    color: theme.colors.brandAction,
  },

  sizeSmall: {
    ...theme.typography.h6,
  },

  disabled: {
    color: theme.colors.greyCc,
  },
});

const useVariantTextStyles = makeStyles(getVariantTextStyles);

const getVariantIconStyles = (theme) => {
  const {
    colorPrimary,
    colorSecondary,
    colorPure,
    colorDanger,
    colorGreen,
  } = getVariantDefaultStyles(theme);

  return {
    root: {
      padding: 11,
      fontSize: 16,
      borderRadius: theme.borderRadius.small,
    },

    colorPrimary,
    colorSecondary,
    colorPure,
    colorDanger,
    colorGreen,

    sizeSmall: {
      fontSize: 12,
    },

    disabled: {},
  };
};

const useVariantIconStyles = makeStyles(getVariantIconStyles);

const useBaseStyles = makeStyles({ root: {}, disabled: {} });

export const useButtonStyles = (variant) => {
  const variantBaseStyles = useBaseStyles();
  const variantDefaultStyles = useVariantDefaultStyles();
  const variantTextStyles = useVariantTextStyles();
  const variantIconStyles = useVariantIconStyles();

  return useMemo(() => {
    switch (variant) {
      case 'base': {
        return variantBaseStyles;
      }
      case 'text': {
        return variantTextStyles;
      }
      case 'icon': {
        return variantIconStyles;
      }
      default: {
        return variantDefaultStyles;
      }
    }
  }, [variant, variantBaseStyles, variantDefaultStyles, variantIconStyles, variantTextStyles]);
};
